export default "__VITE_ASSET__CAdHhi$d__"